import React from 'react'
import { ossImg } from 'meinian-package/src/utils/image'
import CollectGroupBtn from '../../../../component/collectGroupBtn'
import OriginLink from '../../../../component/waterfall.card/originLink'
import styles from './index.module.less'

export default ({ columnWidth, itemData }) => {
  return <div style={{ width: columnWidth, height: Math.round((columnWidth * itemData.height) / itemData.width) }}>
    <div
      className={styles['mn-exclusive-card']}
    >
      <CollectGroupBtn
        className={styles.collect}
        currentBlog={itemData}
      />
      <OriginLink
        item={{
          ...itemData,
          childEntityId: itemData.imageGroupEntityId,
          childPlatformId: itemData.platformId
        }}
        platformId={itemData.platformId}
      >
        <img
          loading="lazy"
          src={ossImg(itemData.mainUrl, 400)}
          style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '9px' }}
        />
      </OriginLink>
    </div>
  </div>
}
